import type { BoggleBadgeId } from '~/boggle/config/badges/types'
import { BOGGLE_NON_TIERED_BADGE_IDS } from '~/boggle/config/badges/nonTieredBadgeIds'

import type { BoggleBadgeCheck } from './checkTypes'
import { corneredCheck } from './rules/corneredCheck'
import { doubleDoubleCheck } from './rules/doubleDoubleCheck'
import { explorerCheck } from './rules/explorerCheck'
import { isogramCheck } from './rules/isogramCheck'
import { longStartCheck } from './rules/longStartCheck'
import { luckyCharmCheck } from './rules/luckyCharmCheck'
import { masterCheck } from './rules/masterCheck'
import { palindromeCheck } from './rules/palindromeCheck'
import { sorcererCheck } from './rules/sorcererCheck'
import { spellingBeeCheck } from './rules/spellingBeeCheck'
import { squareCheck } from './rules/squareCheck'
import { straightCheck } from './rules/straightCheck'
import { straightForwardCheck } from './rules/straightForwardCheck'
import { strongStartCheck } from './rules/strongStartCheck'
import { tartarSauceCheck } from './rules/tartarSauceCheck'
import { verboseCheck } from './rules/verboseCheck'

const NON_TIERED_CHECKS: Record<
  (typeof BOGGLE_NON_TIERED_BADGE_IDS)[number],
  BoggleBadgeCheck
> = {
  cornered: corneredCheck,
  doubleDouble: doubleDoubleCheck,
  explorer: explorerCheck,
  isogram: isogramCheck,
  longStart: longStartCheck,
  luckyCharm: luckyCharmCheck,
  master: masterCheck,
  sorcerer: sorcererCheck,
  palindrome: palindromeCheck,
  spellingBee: spellingBeeCheck,
  square: squareCheck,
  straight: straightCheck,
  straightForward: straightForwardCheck,
  strongStart: strongStartCheck,
  tartarSauce: tartarSauceCheck,
  verbose: verboseCheck,
}

export const BOGGLE_BADGE_CHECKS: Record<BoggleBadgeId, BoggleBadgeCheck> =
  NON_TIERED_CHECKS as Record<BoggleBadgeId, BoggleBadgeCheck>
